<template>
    <span>
        {{ $t('rubinred.ecommerce.orders.checkout.bank') }}: {{ bank }}
    </span>
</template>

<script>
  export default {
    computed: {
      bank() {
        return this.$store.state.checkout.payment.handlerData ? this.$store.state.checkout.payment.handlerData.bankName : null;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/GestpayMybankSummary.vue